import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { getSession } from '@/lib/session';
import { canAccessGabineto } from '@/auth/gabinetoAccess';

export default function RequireGabineto({ children }: PropsWithChildren) {
  const session = typeof window !== 'undefined' ? getSession() : null;
  const user = session?.user;

  if (!canAccessGabineto(user?.email, user?.role)) {
    return <Navigate to="/home" replace />;
  }

  return children;
}
